webpackJsonp([29],{

/***/ 1112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawsResult_vue__ = __webpack_require__(1263);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0efc4d16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawsResult_vue__ = __webpack_require__(1398);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawsResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0efc4d16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawsResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composables_draws_useDrawsResult__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_api_draws__ = __webpack_require__(439);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'DrawsResult',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */]
  },
  setup: function setup() {
    var vm = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])();
    var route = vm.proxy.$route;
    var router = vm.proxy.$router;
    var eventId = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return route.params.eventId;
    });
    var round = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return route.params.round;
    });
    var judge = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
    var eventName = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
    var rounds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);

    var _useDrawsResult = Object(__WEBPACK_IMPORTED_MODULE_2__composables_draws_useDrawsResult__["a" /* default */])(eventId.value),
        results = _useDrawsResult.results,
        topCutout = _useDrawsResult.topCutout,
        hasWinner = _useDrawsResult.hasWinner,
        loading = _useDrawsResult.loading,
        fetchResults = _useDrawsResult.fetchResults,
        setWinner = _useDrawsResult.setWinner;

    var activeRoundLabel = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      var r = parseInt(round.value, 10);
      var totalRounds = rounds.value.length;

      if (r === totalRounds) {
        return 'final round';
      }

      var found = rounds.value.find(function (item) {
        return item.id === r;
      });
      return found != null ? found.label : '';
    });

    function goBack() {
      router.back();
    }

    function makeWinner(_x) {
      return _makeWinner.apply(this, arguments);
    }

    function _makeWinner() {
      _makeWinner = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(drawId) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return setWinner(drawId);

              case 2:
                _context2.next = 4;
                return fetchResults(round.value);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _makeWinner.apply(this, arguments);
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res, data, draft;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__services_api_draws__["a" /* default */].getEventMeta(eventId.value);

            case 3:
              res = _context.sent;
              data = res.data.data;
              draft = data.draft != null ? data.draft : {};
              eventName.value = draft.eventName != null ? draft.eventName : '';
              judge.value = draft.judgeName != null ? draft.judgeName : '';
              rounds.value = data.rounds != null ? data.rounds : [];
              _context.next = 13;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);

            case 13:
              _context.next = 15;
              return fetchResults(round.value);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    })));
    return {
      eventId: eventId,
      round: round,
      activeRoundLabel: activeRoundLabel,
      judge: judge,
      eventName: eventName,
      rounds: rounds,
      results: results,
      topCutout: topCutout,
      hasWinner: hasWinner,
      loading: loading,
      goBack: goBack,
      makeWinner: makeWinner
    };
  }
}));

/***/ }),

/***/ 1397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDrawsResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_draws__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_EventBus__ = __webpack_require__(18);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function useDrawsResult(eventId) {
  var results = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var topCutout = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var hasWinner = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);

  function fetchResults(_x) {
    return _fetchResults.apply(this, arguments);
  }

  function _fetchResults() {
    _fetchResults = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(round) {
      var res, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].getRoundResults(eventId, round);

            case 4:
              res = _context.sent;
              data = res.data.data;
              results.value = data.results != null ? data.results : [];
              topCutout.value = data.topCutout != null ? data.topCutout : [];
              hasWinner.value = data.hasWinner != null ? data.hasWinner : false;
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              results.value = [];
              topCutout.value = [];

            case 15:
              _context.prev = 15;
              loading.value = false;
              return _context.finish(15);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11, 15, 18]]);
    }));
    return _fetchResults.apply(this, arguments);
  }

  function setWinner(_x2) {
    return _setWinner.apply(this, arguments);
  }

  function _setWinner() {
    _setWinner = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(drawId) {
      var res, data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_draws__["a" /* default */].setWinner(drawId);

            case 3:
              res = _context2.sent;
              if (res.data.message) __WEBPACK_IMPORTED_MODULE_2__store_EventBus__["a" /* default */].$emit('show-success', res.data.message);
              data = res.data.data;

              if (data != null) {
                hasWinner.value = data.isWinner;
              }

              _context2.next = 11;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));
    return _setWinner.apply(this, arguments);
  }

  return {
    results: results,
    topCutout: topCutout,
    hasWinner: hasWinner,
    loading: loading,
    fetchResults: fetchResults,
    setWinner: setWinner
  };
}

/***/ }),

/***/ 1398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('div',{staticClass:"wrap-drafts"},[_c('h3',[_vm._v("Judge: "+_vm._s(_vm.judge))]),_vm._v(" "),_c('h2',{staticClass:"drafts__title"},[_vm._v("Results of "+_vm._s(_vm.eventName)+" ("+_vm._s(_vm.activeRoundLabel)+")")]),_vm._v(" "),_c('div',{staticClass:"draws-table draws-event"},[_c('table',{attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v("Rider")]),_vm._v(" "),_c('th',[_vm._v("Horse")]),_vm._v(" "),_c('th',[_vm._v("Owner")]),_vm._v(" "),_c('th',[_vm._v("Score")])])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"spacer"},[_c('td')]),_vm._v(" "),_vm._l((_vm.results),function(row){return _c('tr',{key:row.id},[_c('td',[_vm._v(_vm._s(row.place))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.competitorName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.horseName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.ownerName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.score))])])})],2)]),_vm._v(" "),_c('div',{staticClass:"submit"},[_c('a',{staticClass:"btn-default",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_vm._v("Back to Draws")])])]),_vm._v(" "),_c('h2',{staticClass:"drafts__title"},[_vm._v("Highest Cutouts")]),_vm._v(" "),_c('div',{staticClass:"draws-table draws-event"},[_c('table',{attrs:{"cellpadding":"0","cellspacing":"0"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Rider")]),_vm._v(" "),_c('th',[_vm._v("Horse")]),_vm._v(" "),_c('th',[_vm._v("Cutout")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"spacer"},[_c('td')]),_vm._v(" "),_vm._l((_vm.topCutout),function(c){return _c('tr',{key:c.id},[_c('td',[_vm._v(_vm._s(c.rider))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(c.horse))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(c.cutout))]),_vm._v(" "),_c('td',[(_vm.hasWinner)?[(c.isWinner)?_c('span',[_vm._v("Winner!")]):_vm._e()]:_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.makeWinner(c.id)}}},[_vm._v("Make Winner")])],2)])})],2)]),_vm._v(" "),_c('div',{staticClass:"submit"},[_c('a',{staticClass:"btn-default",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_vm._v("Back to Draws")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/29.1cf23d7316ae5b8a9411.js